/**
 * Templates Service
 * API client pour les templates documents et emails
 */

import api from '@/utils/api';
import { emailTemplatesAPI } from '@/utils/api';

// ==================== Types ====================

export interface DocumentTemplate {
  id: string;
  name: string;
  displayName?: string;
  description?: string;
  type: 'INVOICE' | 'QUOTE' | 'CREDIT_NOTE' | 'WORK_ORDER' | 'PROGRESS_INVOICE';
  styleConfig: any;
  layoutConfig: any;
  previewImageUrl?: string | null;
  isPremium: boolean;
  minPlanLevel?: string;
  isSystemTemplate: boolean;
  isActive: boolean;
  canUse?: boolean;
  userPlanCode?: string;
}

export interface CurrentTemplates {
  invoiceTemplateId: string;
  quoteTemplateId: string;
  invoiceTemplateName: string;
  quoteTemplateName: string;
  invoiceTemplateDisplayName: string;
  quoteTemplateDisplayName: string;
  canUseInvoiceTemplate: boolean;
  canUseQuoteTemplate: boolean;
}

// ==================== API ====================

export const documentTemplatesAPI = {
  /**
   * GET /templates/available - Templates disponibles
   */
  getAvailable: async (): Promise<DocumentTemplate[]> => {
    const response = await api.get('/templates/available') as { data: DocumentTemplate[] };
    return response.data || [];
  },

  /**
   * GET /templates/current - Templates actuellement sélectionnés
   */
  getCurrent: async (): Promise<CurrentTemplates | null> => {
    const response = await api.get('/templates/current') as { data: CurrentTemplates | null };
    return response.data ?? null;
  },

  /**
   * PUT /templates/preferences/batch - Sauvegarder les préférences templates
   */
  savePreferences: async (data: {
    invoiceTemplateId: string;
    quoteTemplateId: string;
  }): Promise<void> => {
    await api.put('/templates/preferences/batch', data);
  },
};

// ==================== Exports ====================

export const templatesService = {
  email: emailTemplatesAPI,
  documents: documentTemplatesAPI,
};
